import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {media} from "../../../helpers/mixins";

const ImageWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
`; // prettier-ignore

/**
 * FluidImageWrapper component
 * @param {Object} props.children - children node
 * @returns {JSX}
 */
const FluidImageWrapper = ({ children }) => (
  <ImageWrapper>{children}</ImageWrapper>
);

FluidImageWrapper.propTypes = {
  children: PropTypes.node
};

export default FluidImageWrapper;
